// @ts-strict-ignore
import * as React from 'react';
import { clsx } from 'clsx';
import { Button, Typography } from 'onboarding-components';
import styles from './banner.module.styl';
export enum BannerType {
  Info = "info",
  Marketing = "marketing",
}
const backgroundColorStyle = {
  [BannerType.Info]: styles.infoColor,
  [BannerType.Marketing]: styles.marketingColor
};
export const Banner = _ref => {
  let {
    children,
    type = BannerType.Info,
    isVisible = true
  } = _ref;
  if (!isVisible) {
    return null;
  }
  return <div className={clsx(styles.banner, backgroundColorStyle[type])} data-sentry-component="Banner" data-sentry-source-file="banner.tsx">{children}</div>;
};
Banner.Content = _ref2 => {
  let {
    children = null,
    title,
    description = null
  } = _ref2;
  return <>
      {children}
      <div className={styles.bannerContent}>
        <div>
          <div className={styles.bannerTitle}>
            <Typography variant='bodySm' weight='bold'>
              {title}
            </Typography>
          </div>
          {description && <div className={styles.bannerDescription}>
              <Typography variant='bodySm' weight='regular'>
                {description}
              </Typography>
            </div>}
        </div>
      </div>
    </>;
};
Banner.Image = _ref3 => {
  let {
    src,
    height,
    width
  } = _ref3;
  return <img className={styles.bannerImage} src={src} height={height} width={width} />;
};
Banner.Action = _ref4 => {
  let {
    action,
    actionName
  } = _ref4;
  return <div className={styles.action}>
      <Button onClick={action} variant='inline' includeArrow={false}>
        {actionName}
      </Button>
    </div>;
};